// AddLead.tsx
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateIsOpenAddLead } from "../../store/slices/commonSlice";
import { addKanbanData, fetchKanbanData } from "../../store/slices/kanbanSlice";
import LeadForm from "./LeadForm";
import ILeadData from "../../models/LeadData.model";
import { RootDispatch, RootState } from "../../store";

const AddLead: React.FC = () => {
  const dispatch = useDispatch<RootDispatch>();
  const { isOpenAddLead } = useSelector((state: RootState) => state.common);
  const kanbanCols = useSelector((state: RootState) => state.kanban.columns);
  const options = Object.values(kanbanCols).map((column) => column.name);

  const handleSubmit = async (data: ILeadData) => {
    const res = await dispatch(addKanbanData(data));
    if (res.payload) {
      dispatch(updateIsOpenAddLead(false));
      dispatch(fetchKanbanData({}));
    }
  };
  return isOpenAddLead ? (
    <LeadForm
      statusOptions={options}
      onSubmit={handleSubmit}
      onClose={() => dispatch(updateIsOpenAddLead(false))}
    />
  ) : null;
};

export default AddLead;
